import { useCatalogApi } from "../api/CatalogApiClient";
import { CatalogFrontendService } from "../services/CatalogFrontendService";

export const useCatalogService = (): CatalogFrontendService =>
  new CatalogFrontendService(useCatalogApi());
